import React from "react";
import { useTranslation } from "react-i18next";
import { Button, Card } from "react-bootstrap";
import { toDateTimeFR } from "../../../utils/datesHeures";
import { BiMessageDetail } from "react-icons/bi";

const ComponentEspace = (props) => {
  const { t } = useTranslation();
  const { espaceObject } = props;

  const espacePrive = () => {
    if (parseInt(espaceObject.conf_publique) === 1) {
      return false;
    } else {
      return true;
    }
  };
  return (
    <Card
      className={
        "d-flex flex-column justify-content-between align-items-center componentEspace m-2 espaceColidee_o" +
        espaceObject.id_entreprise +
        "p" +
        espaceObject.id_plateforme
      }
    >
      <span className="overflowInContent">
        <a
          href={
            process.env.REACT_APP_URL_COLIDEE +
            "o" +
            espaceObject.id_entreprise +
            "p" +
            espaceObject.id_plateforme
          }
          target="_blank"
          rel="noreferrer"
        >
          <Card.Img variant="top" src={espaceObject.picture} style={{ height: 85 }} />
          {espacePrive() && <div className="private">{t("public.componentEspace.private")}</div>}
          <Card.Body>
            <Card.Text className="text-end">
              {t("public.componentEspace.type")}
              <br /> <BiMessageDetail size="1.5em" /> {espaceObject.NbrContributions}
            </Card.Text>
            <Card.Title> {espaceObject.nom}</Card.Title>
            <Card.Text className="flex-grow-1">
              {t("public.componentEspace.lastPublication")} :{" "}
              {toDateTimeFR(espaceObject.dateDerniereContrib)}
            </Card.Text>
          </Card.Body>
        </a>
      </span>
      <Button
        href={
          process.env.REACT_APP_URL_COLIDEE +
          "o" +
          espaceObject.id_entreprise +
          "p" +
          espaceObject.id_plateforme +
          "?openParticiper=1"
        }
        target="_blank"
        rel="noreferrer"
        className="buttonCard"
      >
        {t("public.boutons.je_participe")}
      </Button>
    </Card>
  );
};

export default ComponentEspace;
